module.exports = __webpack_public_path__ + "static/smashing-logo-28dafd244ce3a19c6b4aa8920536a741.svg";